<template>
  <div
    class="purchasable-item-select"
  >
    <div
      v-if="!loading"
    >
      <div
        class="form-group"
      >
        <label
          :for="selectName"
        >
          {{ lbl }}
        </label>

        <select
          :name="selectName"
          :multiple="multiple"
          class="form-control"
          v-on:change="emitChange"
        >
          <option
            value=""
            v-if="!multiple"
          >
            Select an Item
          </option>
          <option
            v-for="item in filteredPurchasableItems"
            :value="item.id"
            :selected="item.selected"
          >
            {{ item.name }}
          </option>
        </select>
      </div>

      <div
        class="form-group"
        v-if="allowSearch"
      >
        <label
          for="search-purchasable-items"
        >
          Search Purchasable Items
        </label>

        <input
          type="search"
          class="form-control"
          id="search-purchasable-items"
          v-model="search.name"
        />
      </div>
      <div
        class="form-group text-right"
      >
        <label
          class="form-check-label"
          for="search-subscriptions-only"
        >
          <input
            type="checkbox"
            class="form-input-checkbox"
            id="search-subscriptions-only"
            v-model="search.subscriptions"
          /> Subscriptions Only?
        </label>
      </div>
    </div>
    <spinner
      size="huge"
      v-else
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Spinner from 'vue-simple-spinner'

export default {
  data () {
    return {
      search: {
        name: '',
        subscriptions: undefined
      }
    }
  },

  props: {
    allowSearch: {
      type: Boolean,
      default: false
    },

    lbl: {
      type: String,
      default: 'Purchasable Items'
    },

    multiple: {
      type: Boolean,
      default: false
    },

    selectId: {
      type: String,
      default: undefined
    },

    selected: {
      type: Array,
      default: () => { return [] }
    }
  },

  computed: mapState({
    filteredPurchasableItems () {
      let items = this.purchasable_items

      if (this.search.subscriptions === true) {
        items = items.filter(item => item.subscription)
      }

      if (this.search.name.length) {
        const regex = new RegExp('^.*?' + this.search.name + '.*?$', 'is')
        items = items.filter(item => item.name.match(regex))
      }

      if (this.selected.length) {
        items = items.map(item => {
          item.selected = this.selected.includes(item.id)
          return item
        })

        // Bump selected items to the top of the list.
        items.sort((a, b) => b.selected - a.selected)
      }

      return items
    },

    selectName () {
      return this.selectId || (
        'purchasable_item' + (
          this.multiple ? 's' : ''
        )
      )
    },

    base: state => state.base,
    loading: state => state.PurchasableItemModule.loading,
    purchasable_items: state => state.PurchasableItemModule.purchasable_items
  }),

  components: {
    'spinner': Spinner
  },

  created () {
    this.get()
  },

  methods: {
    emitChange (ev) {
      const item = (
        this.multiple ? ev.target.selectedOptions.map((option) => { option.value }) : ev.target.selectedOptions[0].value
      )

      this.$parent.$emit('purchaseItemChange', item)
      this.$emit('purchaseItemChange', item)
    },

    get () {
      this.$store.dispatch(
        'PurchasableItemModule/getPurchasableItems'
      ).catch(this.$root.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchasableItemSelect.vue